<section>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="container h-100" >
          <div class="d-flex h-100 justify-content-center align-items-center common-spacing">
            <div class="survey-status text-center">
              <h3>ERROR</h3>
              <!-- <h1 style="font-size: 150px; line-height: 1; font-weight: 600;">404</h1> -->
              <img class="img-fluid mb-4" src="../../assets/images/404.png" alt="404" width="500" height="250"/>
              <h2>This page is outside of the universe</h2>
              <p>The page you are trying to access doesn’t exist or has been moved. Try going back to our homepage. </p>
              <br>
               
              <ul class="button justify-content-center">
                <li>
                  <a class="btn btn-outline-primary btn-lg" href="https://opinionest.com/" target="_blank">Go to Homepage</a>
                </li>
                <li>
                  <a class="btn btn-primary btn-lg" href="https://opinionest.com/contact-us" target="_blank">Contact Us</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>